import { useState } from 'react';
import translations from '../../../../translations';
import FormGroup from '../../../generic/FormGroup';
import DataActions from '../common/dataActions/DataActions';
import NameInput from '../common/NameInput';
import OutcomeList from '../common/outcomes/OutcomeList';
import { useMapElement } from '../contextProviders/MapElementProvider';
import ModalBody from '../../../generic/modal/ModalBody';
import ModalFooter from '../../../generic/modal/ModalFooter';
import { isNullOrEmpty } from '../../../../utils/guard';
import Footer from '../common/Footer';

const DeleteConfiguration = () => {
    const [hasSubmitted, updateHasSubmitted] = useState(false);

    const { mapElement, onUpdateName, onUpdateComments, onSaveMapElement, onClose } =
        useMapElement();

    if (!mapElement) {
        onClose();
        return;
    }

    const { developerName, developerSummary } = mapElement;

    const isDeleteElementNameValid = !isNullOrEmpty(developerName);

    const onSave = () => {
        updateHasSubmitted(true);
        if (isDeleteElementNameValid) {
            onSaveMapElement(mapElement);
        }
    };

    const renderBody = () => (
        <>
            <NameInput
                isValid={isDeleteElementNameValid}
                showValidation={hasSubmitted}
                id="delete-element-name"
                name={developerName ?? ''}
                onUpdateName={onUpdateName}
            />
            <DataActions />
            <OutcomeList />
            <FormGroup
                htmlFor="delete-element-comments"
                label="Comments about this Database Delete"
            >
                <textarea
                    id="delete-element-comments"
                    className="form-control form-textarea"
                    value={developerSummary ?? ''}
                    onChange={(e) => onUpdateComments(e.target.value)}
                />
            </FormGroup>
        </>
    );

    const renderFooter = () => {
        return (
            <Footer
                save={onSave}
                saveButtonText={translations.GRAPH_config_panel_save}
                cancel={onClose}
            />
        );
    };

    return (
        <>
            <ModalBody>{renderBody()}</ModalBody>
            <ModalFooter>{renderFooter()}</ModalFooter>
        </>
    );
};

export default DeleteConfiguration;
